<template>
  <div>
    <el-form
      ref="formRef"
      :model="form"
      label-position="top"
      size="small"
    >
      <el-row :gutter="10">
        <el-col :span="24">
          <el-form-item
            :label="$t('mdfeTranslate.Airline')"
            prop="configCode"
            :rules="[
              { required: true, message: $t('collectionCenter.notNull'), trigger: ['blur', 'change']}
            ]"
          >
            <el-select
              v-model="form.configCode"
              :placeholder="$t('collectionCenter.pleaseChoose')"
              clearable
              remote
              :remote-method="getAirlineOption"
              style="width: 100%;"
              @visible-change="getAirlineOptionChange"
            >
              <el-option
                v-for="item in airlineOptions"
                :key="item.configCode"
                :label="item.airlineName"
                :value="item.configCode"
              />
            </el-select>
          </el-form-item>
        </el-col>
        <el-col :span="24">
          <el-form-item
            v-if="pushType === 0"
            :label="$t('mdfeTranslate.MDFEKey')"
            prop="mdfeKey"
            :rules="[
              { required: true, message: $t('collectionCenter.notNull'), trigger: ['blur', 'change']},
              { pattern: /^[a-zA-Z0-9]{44}$/, message: $t('mdfeTranslate.PleaseEnterA44DigitKey'), trigger: ['blur', 'change']}
            ]"
          >
            <el-input
              v-model="form.mdfeKey"
              :placeholder="$t('GlobalSetObj.pleaseInput')"
              maxlength="44"
              show-word-limit
            />
          </el-form-item>
          <el-form-item
            v-if="pushType === 1"
            :label="$t('mdfeTranslate.MDFEKey')"
            prop="mdfeKey"
            :rules="[
              { required: true, message: $t('collectionCenter.notNull'), trigger: ['blur', 'change']}
            ]"
          >
            <el-input
              v-model="form.mdfeKey"
              :placeholder="$t('mdfeTranslate.PleaseEnterMDFeKey')"
              type="textarea"
              :rows="6"
            />
          </el-form-item>
        </el-col>
      </el-row>
    </el-form>
  </div>
</template>

<script>
import {
  airlinePushConfigPageQueryOptions,
  airlinePushRecordAdd,
  airlinePushRecordBatchImport
} from '@/api/invoiceCenter';

export default {
  name: 'Form',
  props: {
    formData: {
      type: Object,
      default: () => {
        return {
          configCode: null,
          mdfeKey: null
        };
      }
    },
    pushType: {
      type: Number,
      default: 0
    }
  },
  data() {
    return {
      form: {},
      airlineOptions: []
    };
  },
  watch: {
    formData: {
      handler(val) {
        this.form = val;
      },
      immediate: true
    }
  },
  created() {
    console.log(this.pushType, '===pushType');
  },
  methods: {
    // 打开选择公司弹窗
    getAirlineOptionChange(val) {
      if (val) {
        this.getAirlineOption();
      }
    },
    // 获取航空公司选项
    getAirlineOption(name = '') {
      const param = {
        pageNumber: 1,
        pageSize: 20,
        params: {
          airlineName: name
        }
      };
      airlinePushConfigPageQueryOptions(param).then(res => {
        if (res.code === 200) {
          this.airlineOptions = res.data.records;
        }
      });
    },
    // 推送
    savePush() {
      this.$refs.formRef.validate(valid => {
        if (valid) {
          if (this.pushType === 0) {
            airlinePushRecordAdd(this.form).then(res => {
              if (res.code === 200) {
                this.$message.success(this.$t('GlobalSetObj.TheOperationSucceeded'));
                this.$emit('savePush', true);
              }
            });
          } else {
            const processString = (str) => {
              // 1. 按换行符切割成数组（支持 \n, \r\n, \r）
              const lines = str.split(/\r?\n|\r/);

              // 2. 清除每个元素的所有空格，并过滤掉空字符串
              const cleaned = lines
                .map(line => line.replace(/\s/g, '')) // 移除所有空格
                .filter(line => line !== ''); // 删除空元素

              // 3. 去重（保留首次出现的顺序）
              const unique = [...new Set(cleaned)];

              return unique;
            };
            const param = {
              configCode: this.form.configCode,
              mdfeKeyList: processString(this.form.mdfeKey)
            };
            airlinePushRecordBatchImport(param).then(res => {
              if (res.code === 200) {
                this.$emit('batchImportResultData', res.data);
              }
            });
          }
        }
      });
    }
  }
};
</script>

<style scoped>

</style>
